var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18,
    r: 18,
    fill: "#F0BD2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2101 26.9208L21.2101 29.9486L18.4609 31.5L15.7899 29.9486L15.7899 26.9208L18.4609 28.4722L21.2101 26.9208ZM6.5 16.4486L9.17101 18L9.17101 23.1923L13.7704 25.8323L13.7704 28.8601L6.5 24.7437L6.5 16.4486ZM30.4218 16.4486L30.4218 24.7563L23.0733 28.8726L23.0733 25.8448L27.6726 23.2048L27.6726 18.0125L30.4218 16.4486ZM23.0603 12.3323L25.8094 13.8837L25.8094 16.9115L21.2101 19.5514L21.2101 24.8188L18.5391 26.3702L15.8811 24.8188L15.8811 19.5389L11.1124 16.899L11.1124 13.8712L13.8616 12.3197L18.4609 14.9597L23.0603 12.3323ZM11.1124 19.076L13.7834 20.6274L13.7834 23.6552L11.1124 22.1038L11.1124 19.076ZM25.8094 19.076L25.8094 22.1038L23.1384 23.6552L23.1384 20.6274L25.8094 19.076ZM9.17101 9.69231L11.9202 11.2437L9.17101 12.7952L9.17101 15.823L6.5 14.2715L6.5 11.2437L9.17101 9.69231ZM27.7508 9.69231L30.5 11.2437L30.5 14.2715L27.7508 15.823L27.7508 12.7952L25.0798 11.2437L27.7508 9.69231ZM18.4609 9.69231L21.2101 11.2437L18.4609 12.7952L15.7899 11.2437L18.4609 9.69231ZM18.4609 4.5L25.8094 8.61631L23.1384 10.1677L18.5391 7.5278L13.8485 10.1677L11.1775 8.61631L18.4609 4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.9556afcb69d70a2cd57f8e7f263e7895.svg";
export { ForwardRef as ReactComponent };